import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 99999999999999;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  width: auto;
  height: auto;
  border-radius: 5px;
  padding: 50px;

  @media (max-width: 430px) {
    width: 95%;
    padding: 30px;
  }
`;

export const ModalContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .modal-message {
    display: flex;

    h2 {
      text-align: center;
    }
  }

  .modal-buttons {
    display: flex;

    .btn-cancel {
      padding: 10px 30px;
      margin: 10px;
      font-weight: 600;
      color: #37474f;
      background-color: #eceff1;
      border: 1px solid #90a4ae;
      border-radius: 7px;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
    .btn-ativar {
      padding: 10px 30px;
      margin: 10px;
      font-weight: 600;
      color: #fff;
      background-color: var(--azul-razio);
      border: 1px solid var(--azul-razio);
      border-radius: 7px;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
    .btn-pausar {
      padding: 10px 30px;
      margin: 10px;
      font-weight: 600;
      color: #fff;
      background-color: var(--red-razio);
      border: 1px solid var(--red-razio);
      border-radius: 7px;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }

  @media (max-width: 430px) {
  }

  @media (max-width: 400px) {
  }
`;
